import { Param, ParamUtils } from "./Param";

// ApplyFunction interface
export interface ApplyFunction {
  readonly functionName: string;
  readonly functionParams?: Param[];
  // readonly params?: Param[];
}

// Utility functions for ApplyFunction
export const ApplyFunctionUtils = {
  // Create a new ApplyFunction
  create({
    functionName,
    functionParams,
    // params,
  }: {
    functionName: string;
    functionParams?: Param[];
    // params?: Param[];
  }): ApplyFunction {
    return {
      functionName,
      functionParams,
      // params,
    };
  },

  // Create empty ApplyFunction
  empty(): ApplyFunction {
    return {
      functionName: "",
      functionParams: [],
      // params: [],
    };
  },

  // Create from map
  fromMap(map: { [key: string]: any }): ApplyFunction {
    try {
      return {
        functionName: map["functionName"] ?? "",
        functionParams: map["functionParams"]
          ? map["functionParams"].map((e: any) => ParamUtils.fromMap(e))
          : [],
        // params: map["params"] ? map["params"].map((e: any) => ParamUtils.fromMap(e)) : [],
      };
    } catch (e) {
      console.error(e);
      return ApplyFunctionUtils.empty();
    }
  },

  // Convert to map
  toMap(applyFunction: ApplyFunction): { [key: string]: any } {
    const map: { [key: string]: any } = { functionName: applyFunction.functionName };
    if (applyFunction.functionParams) {
      map["functionParams"] = applyFunction.functionParams.map((fp) => ParamUtils.toMap(fp));
    }
    // if (applyFunction.params) {
    //   map["params"] = applyFunction.params.map((fp) => ParamUtils.toMap(fp));
    // }
    return map;
  },

  // Convert to JSON
  toJson(applyFunction: ApplyFunction): string {
    return JSON.stringify(ApplyFunctionUtils.toMap(applyFunction));
  },

  // Equality check
  equals(af1: ApplyFunction, af2: ApplyFunction): boolean {
    if (af1 === af2) return true;
    return (
      af1.functionName === af2.functionName &&
      JSON.stringify(af1.functionParams) === JSON.stringify(af2.functionParams) // &&
      // JSON.stringify(af1.params) === JSON.stringify(af2.params)
    );
  },

  // Update function name (returns new object)
  withFunctionName(applyFunction: ApplyFunction, functionName: string): ApplyFunction {
    return { ...applyFunction, functionName };
  },

  // Update function params (returns new object)
  withFunctionParams(applyFunction: ApplyFunction, functionParams: Param[]): ApplyFunction {
    return { ...applyFunction, functionParams };
  },

  // Update params (returns new object)
  // withParams(applyFunction: ApplyFunction, params: Param[]): ApplyFunction {
  //   return { ...applyFunction, params };
  // },

  // Add a function parameter (returns new object)
  addFunctionParam(applyFunction: ApplyFunction, param: Param): ApplyFunction {
    const currentParams = applyFunction.functionParams || [];
    return { ...applyFunction, functionParams: [...currentParams, param] };
  },

  // Add a parameter (returns new object)
  // addParam(applyFunction: ApplyFunction, param: Param): ApplyFunction {
  //   const currentParams = applyFunction.params || [];
  //   return { ...applyFunction, params: [...currentParams, param] };
  // },
};
